import React from "react";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";

const AdminLayout = ({ children, title }) => {
  return (
    <div className="min-h-screen bg-[#f5f6f8] text-[#172b3a]">
      <AdminSidebar />

      <div className="ml-[165px] min-h-screen">
        <AdminHeader title={title} />

        <main className="p-5 lg:p-6">
          {children}
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;